import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Retorno } from '@/models/comboModel';
import { environment } from '@/../environments/environment';
import { AtividadeAnexo } from '../models/atividade-anexo';

@Injectable({
  providedIn: 'root',
})
export class AtividadeAnexosService {
  private environmentUrl: string = '';

  constructor(private httpClient: HttpClient) {
    this.environmentUrl = environment.ApiCore;
  }

  getAtividadeAnexos(idAtividade: number): Observable<AtividadeAnexo[]> {
    const url = this.environmentUrl + `v3/atividade/${idAtividade}/anexos`;
    return this.httpClient.get<AtividadeAnexo[]>(url);
  }

  upload(formData: FormData, idAtividade: number): Observable<any> {
    const url = this.environmentUrl + 'v3/atividade/' + idAtividade + '/anexos';
    return this.httpClient.post(url, formData);
  }

  deleteAnexo(idAtivadeAnexo: any) {
    const url = this.environmentUrl + 'v3/atividade/anexos/' + idAtivadeAnexo;
    return this.httpClient.delete(url);
  }
}
